import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatRippleModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { AiGenerateTextComponent } from './ai-generate-text.component';
import { MessageDescriptionDialogComponent } from './message-description-dialog/message-description-dialog.component';

import { AiGenerateTextService } from './ai-generate-text.service';

@NgModule({
  declarations: [AiGenerateTextComponent, MessageDescriptionDialogComponent],
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,

    MatMenuModule,
    MatIconModule,
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatRippleModule,
    MatDividerModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
  ],
  exports: [AiGenerateTextComponent],
  providers: [AiGenerateTextService],
})
export class AiGenerateTextModule { }
